import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PanelModule } from 'primeng/panel';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TranslocoRootModule } from 'src/app/transloco-root.module';
import { TranslocoService } from '@ngneat/transloco';
import { InvoiceService } from 'src/app/service/invoice.service';
import { InvoiceSummary, NfStatus } from 'src/app/model/response/invoice-response';

@Component({
  selector: 'app-invoice-list-panel',
  standalone: true,
  imports: [CommonModule, PanelModule, TableModule, TagModule, ButtonModule, TooltipModule, ProgressSpinnerModule, TranslocoRootModule],
  templateUrl: './invoice-list-panel.component.html',
  styleUrl: './invoice-list-panel.component.css',
})
export class InvoiceListPanelComponent {
  @Output() viewDetails = new EventEmitter<string>();

  invoices: InvoiceSummary[] = [];
  invoicesLoaded: boolean = false;
  invoicesLoading: boolean = false;
  invoicesError: boolean = false;

  constructor(
    private invoiceService: InvoiceService,
    private translocoService: TranslocoService,
  ) {}

  onPanelToggle(expanded: boolean): void {
    if (expanded && !this.invoicesLoaded && !this.invoicesLoading) {
      this.loadInvoices();
    }
  }

  loadInvoices(): void {
    this.invoicesLoading = true;
    this.invoicesError = false;
    this.invoiceService.getInvoices().subscribe({
      next: (data) => {
        this.invoices = data;
        this.invoicesLoaded = true;
        this.invoicesLoading = false;
      },
      error: () => {
        this.invoicesLoading = false;
        this.invoicesError = true;
      },
    });
  }

  nfStatusSeverity(status: NfStatus): 'secondary' | 'warning' | 'info' | 'success' | 'danger' {
    const map: Record<NfStatus, 'secondary' | 'warning' | 'info' | 'success' | 'danger'> = {
      not_applicable: 'secondary',
      pending: 'warning',
      // Sem cor de info no design system (o azul do PrimeNG era a unica
      // ocorrencia dele no app). 'pending' e 'requested' sao os dois estados em
      // andamento e dividem o ambar; o rotulo da pilula distingue um do outro.
      requested: 'warning',
      issued: 'success',
      failed: 'danger',
    };
    return map[status];
  }

  nfStatusLabel(status: NfStatus): string {
    return this.translocoService.translate(`user.account.subscriptionTab.invoices.nfStatus.${status}`);
  }

  displayName(item: InvoiceSummary): string {
    return item.tokenPackageID ? (item.tokenPackageName ?? '') : item.planName;
  }

  typeLabel(item: InvoiceSummary): string {
    return this.translocoService.translate(
      item.tokenPackageID
        ? 'user.account.subscriptionTab.invoices.typeTokenPurchase'
        : 'user.account.subscriptionTab.invoices.typeSubscription'
    );
  }
}
